import rulesets from "../lib/rulesets";

rulesets.install = Vue => {
  Vue.prototype.$rulesets = rulesets;
};

export default rulesets;
